"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "12",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "8",
  r: "1"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "16",
  r: "1"
}, "3"), /*#__PURE__*/_jsx("path", {
  d: "M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}, "4"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "12",
  r: "1"
}, "5"), /*#__PURE__*/_jsx("path", {
  d: "M3 3h18v2H3z"
}, "6"), /*#__PURE__*/_jsx("circle", {
  cx: "5",
  cy: "8",
  r: "1.5"
}, "7"), /*#__PURE__*/_jsx("circle", {
  cx: "5",
  cy: "12",
  r: "1.5"
}, "8"), /*#__PURE__*/_jsx("circle", {
  cx: "5",
  cy: "16",
  r: "1.5"
}, "9"), /*#__PURE__*/_jsx("path", {
  d: "M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}, "10"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "16",
  r: "1"
}, "11"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "8",
  r: "1"
}, "12"), /*#__PURE__*/_jsx("path", {
  d: "M3 19h18v2H3z"
}, "13")], 'BlurLinearTwoTone');